// extracted by mini-css-extract-plugin
module.exports = {"myParallax":"ParallaxEffect_myParallax__3cq6V","fullWidth":"ParallaxEffect_fullWidth__HSGzI"};